const contentDisplayView = {
  content: 'content',
  info: 'info',
  questions: 'questions'
};

export default contentDisplayView;



// WEBPACK FOOTER //
// ./src/constants/content-display-view.js